import { useMutation, useQueryClient } from '@tanstack/react-query'
import { UpdateMailSettingDto } from '@myapp/contract'
import { mailSettingsApi } from './service'
import { mailSettingsKeys } from './keys'

export function useUpdateMailSettings() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: UpdateMailSettingDto) =>
      mailSettingsApi.update(data).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: mailSettingsKeys.detail() })
    },
  })
}

export function useTestMailSettings() {
  return useMutation({
    mutationFn: () => mailSettingsApi.test().then((r) => r.data),
  })
}
